import { render, staticRenderFns } from "./FooterLogin.vue?vue&type=template&id=d0f7454e&"
import script from "./FooterLogin.vue?vue&type=script&lang=js&"
export * from "./FooterLogin.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogin.vue?vue&type=style&index=0&id=d0f7454e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports